import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { HoursInput } from "@/components/common/HoursInput";
import { fmtMinutes } from "@/lib/interventions";
import { AlertDialog, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

// complete=true: completa l'attività d'intervento con ore effettive obbligatorie; altrimenti corregge le ore.
export const WorkedDialog = ({ a, complete, onClose, onDone }) => {
  const [v, setV] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { setV(complete ? null : a?.worked_minutes ?? null); }, [a, complete]);
  const save = async () => {
    setBusy(true);
    try {
      if (complete) { await api.post(`/activities/${a.id}/complete`, { worked_minutes: v }); toast.success("Attività completata"); }
      else { await api.patch(`/activities/${a.id}`, { worked_minutes: v }); toast.success("Ore lavorate aggiornate"); }
      onDone(); onClose();
    } catch (e) { toast.error(errorMessage(e)); } finally { setBusy(false); }
  };
  return (
    <AlertDialog open={!!a} onOpenChange={(o) => !o && onClose()}>
      <AlertDialogContent data-testid="activity-worked-dialog">
        <AlertDialogHeader><AlertDialogTitle>{complete ? "Completa: ore effettivamente lavorate" : "Ore effettivamente lavorate"}</AlertDialogTitle>
          <AlertDialogDescription>{a?.title}. {complete ? "Obbligatorie per completare: " : ""}il totale popola l'intervento e il rapportino.
            {complete && a?.worked_minutes ? ` Previste: ${fmtMinutes(a.worked_minutes)}.` : ""}</AlertDialogDescription></AlertDialogHeader>
        <HoursInput value={v} onChange={setV} testId="activity-worked-input" />
        <AlertDialogFooter><AlertDialogCancel>Annulla</AlertDialogCancel>
          <Button onClick={save} disabled={busy || v == null || (complete && v <= 0)} data-testid="activity-worked-save">{complete ? "Completa" : "Salva"}</Button></AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
